// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Toasts === */
.toast-ausha {
    border-radius: var(--r-xs) !important;
    width: 100%;
    padding: 8px 10px !important;
    min-height: 0 !important;
    align-items: center !important;
    margin: 25px auto 0 !important;
}

.toast-ausha-success {
    background: var(--success);
}

.toast-ausha-error {
    background: var(--alert);
}

/* === Apex Charts === */
.apexcharts-tooltip {
    transform: translate(0%, -70px);
}

.tooltip-ausha-apexChart .tooltip-ausha-apexChart-day,
.tooltip-ausha-apexChart .tooltip-ausha-apexChart-listen {
    font-size: var(--fs-body);
    text-align: center;
    padding: 10px;
}

.tooltip-ausha-apexChart .tooltip-ausha-apexChart-day {
    background: var(--neutral50);
    color: var(--neutral500);
}

.tooltip-ausha-apexChart-capitalize {
    text-transform: capitalize;
}

.custom-ausha-barChart .apexcharts-series path {
    stroke-linejoin: round;
    stroke-width: 4;
    stroke: var(--primary);
}

/* === DraftJS === */
.custom-draft-editor {
    border-radius: var(--r-xs);
    padding: 10px;
    border: 1px solid var(--neutral200);
    color: var(--black);
    font-size: var(--fs-body);
    min-height: 120px;
    max-height: 300px;
}

.custom-draft-editor:hover {
    border: 1px solid var(--neutral500);
}

.custom-draft-editor .public-DraftStyleDefault-block {
    margin: 0 !important;
}

.custom-draft-editor .public-DraftStyleDefault-ul,
.custom-draft-editor .public-DraftStyleDefault-ol {
    margin: 10px 0 !important;
}

.custom-draft-editor-error {
    border-radius: var(--r-xs);
    padding: 10px;
    border: 1px solid var(--alert);
    color: var(--black);
    font-size: var(--fs-body);
    min-height: 120px;
    max-height: 300px;
}

.custom-draft-editor-error:hover {
    border: 1px solid var(--alert);
}

.custom-draft-editor-error .public-DraftStyleDefault-block {
    margin: 0 !important;
}

.custom-draft-editor-error .public-DraftStyleDefault-ul,
.custom-draft-editor-error .public-DraftStyleDefault-ol {
    margin: 10px 0 !important;
}

.custom-draft-toolbar {
    border-radius: var(--r-xs) !important;
    padding: 0 !important;
    margin: 5px 0 10px 0 !important;
    border: none !important;
    position: relative;
}

.custom-popup-draft {
    border-radius: var(--r-xs) !important;
    height: max-content !important;
    width: 300px !important;
    top: 38px !important;
    left: 0 !important;
    border: 1px solid var(--neutral100) !important;
    box-shadow: var(--s-medium) !important;
}

.custom-popup-draft #linkTarget {
    color: var(--black);
    border: 1px solid var(--neutral100) !important;
    height: 37px !important;
    padding: 8px 10px !important;
    margin-bottom: 5px !important;
    border-radius: var(--r-xs) !important;
}

.custom-popup-draft #linkTarget:hover {
    border: 1px solid var(--neutral500) !important;
}

.custom-popup-draft #linkTarget:focus {
    border: 1px solid var(--primary) !important;
}

.custom-popup-draft #linkTitle,
.custom-popup-draft .rdw-link-modal-label,
.custom-popup-draft .rdw-link-modal-target-option,
.custom-popup-draft .rdw-link-modal-buttonsection {
    display: none;
}

.custom-popup-draft .rdw-link-modal-buttonsection {
    margin-top: 10px !important;
}

.custom-popup-draft #custom-draft-button-add {
    background: var(--primary) !important;
    color: #ffffff !important;
    border: none !important;
}

.custom-popup-draft #custom-draft-button-add:hover {
    background: var(--primary600) !important;
}

.custom-popup-draft #custom-draft-button-add:disabled {
    background: var(--primary50) !important;
}

.custom-popup-draft .rdw-link-modal-btn {
    box-shadow: none !important;
    margin: 0 5px !important;
    border-radius: var(--r-xs) !important;
    height: 39px !important;
    min-width: 100px !important;
    color: var(--black);
    font-weight: var(--fw-semibold);
}

.custom-popup-draft .rdw-link-modal-btn:hover {
    background: var(--neutral100) !important;
}

.custom-popup-draft::before {
    content: 'Add link';
    color: var(--black);
    font-weight: var(--fw-bold);
    background: var(--neutral50);
    padding: 10px 15px;
    box-sizing: border-box;
    width: calc(100% + 30px);
    transform: translate(-15px, -15px);
}

.custom-draft-button {
    padding: 0;
    min-height: 32px !important;
    min-width: 32px !important;
    border: 1px solid var(--neutral200) !important;
    margin: 0 8px 0 0 !important;
    box-shadow: none !important;
    border-radius: var(--r-xs) !important;
}

.custom-draft-button > img {
    max-height: 14px;
    max-width: 14px;
}

.custom-draft-button:hover,
.custom-draft-button:active {
    background: var(--neutral100) !important;
}

.rdw-option-active {
    background: var(--neutral100) !important;
    box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/third-party-overwrites.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,qCAAqC;IACrC,WAAW;IACX,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wBAAwB;AACxB;IACI,+BAA+B;AACnC;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,0BAA0B;IAC1B,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,+BAA+B;IAC/B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,qCAAqC;IACrC,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,0BAA0B;IAC1B,8CAA8C;IAC9C,4BAA4B;IAC5B,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B","sourcesContent":["/* === Toasts === */\n.toast-ausha {\n    border-radius: var(--r-xs) !important;\n    width: 100%;\n    padding: 8px 10px !important;\n    min-height: 0 !important;\n    align-items: center !important;\n    margin: 25px auto 0 !important;\n}\n\n.toast-ausha-success {\n    background: var(--success);\n}\n\n.toast-ausha-error {\n    background: var(--alert);\n}\n\n/* === Apex Charts === */\n.apexcharts-tooltip {\n    transform: translate(0%, -70px);\n}\n\n.tooltip-ausha-apexChart .tooltip-ausha-apexChart-day,\n.tooltip-ausha-apexChart .tooltip-ausha-apexChart-listen {\n    font-size: var(--fs-body);\n    text-align: center;\n    padding: 10px;\n}\n\n.tooltip-ausha-apexChart .tooltip-ausha-apexChart-day {\n    background: var(--neutral50);\n    color: var(--neutral500);\n}\n\n.tooltip-ausha-apexChart-capitalize {\n    text-transform: capitalize;\n}\n\n.custom-ausha-barChart .apexcharts-series path {\n    stroke-linejoin: round;\n    stroke-width: 4;\n    stroke: var(--primary);\n}\n\n/* === DraftJS === */\n.custom-draft-editor {\n    border-radius: var(--r-xs);\n    padding: 10px;\n    border: 1px solid var(--neutral200);\n    color: var(--black);\n    font-size: var(--fs-body);\n    min-height: 120px;\n    max-height: 300px;\n}\n\n.custom-draft-editor:hover {\n    border: 1px solid var(--neutral500);\n}\n\n.custom-draft-editor .public-DraftStyleDefault-block {\n    margin: 0 !important;\n}\n\n.custom-draft-editor .public-DraftStyleDefault-ul,\n.custom-draft-editor .public-DraftStyleDefault-ol {\n    margin: 10px 0 !important;\n}\n\n.custom-draft-editor-error {\n    border-radius: var(--r-xs);\n    padding: 10px;\n    border: 1px solid var(--alert);\n    color: var(--black);\n    font-size: var(--fs-body);\n    min-height: 120px;\n    max-height: 300px;\n}\n\n.custom-draft-editor-error:hover {\n    border: 1px solid var(--alert);\n}\n\n.custom-draft-editor-error .public-DraftStyleDefault-block {\n    margin: 0 !important;\n}\n\n.custom-draft-editor-error .public-DraftStyleDefault-ul,\n.custom-draft-editor-error .public-DraftStyleDefault-ol {\n    margin: 10px 0 !important;\n}\n\n.custom-draft-toolbar {\n    border-radius: var(--r-xs) !important;\n    padding: 0 !important;\n    margin: 5px 0 10px 0 !important;\n    border: none !important;\n    position: relative;\n}\n\n.custom-popup-draft {\n    border-radius: var(--r-xs) !important;\n    height: max-content !important;\n    width: 300px !important;\n    top: 38px !important;\n    left: 0 !important;\n    border: 1px solid var(--neutral100) !important;\n    box-shadow: var(--s-medium) !important;\n}\n\n.custom-popup-draft #linkTarget {\n    color: var(--black);\n    border: 1px solid var(--neutral100) !important;\n    height: 37px !important;\n    padding: 8px 10px !important;\n    margin-bottom: 5px !important;\n    border-radius: var(--r-xs) !important;\n}\n\n.custom-popup-draft #linkTarget:hover {\n    border: 1px solid var(--neutral500) !important;\n}\n\n.custom-popup-draft #linkTarget:focus {\n    border: 1px solid var(--primary) !important;\n}\n\n.custom-popup-draft #linkTitle,\n.custom-popup-draft .rdw-link-modal-label,\n.custom-popup-draft .rdw-link-modal-target-option,\n.custom-popup-draft .rdw-link-modal-buttonsection {\n    display: none;\n}\n\n.custom-popup-draft .rdw-link-modal-buttonsection {\n    margin-top: 10px !important;\n}\n\n.custom-popup-draft #custom-draft-button-add {\n    background: var(--primary) !important;\n    color: #ffffff !important;\n    border: none !important;\n}\n\n.custom-popup-draft #custom-draft-button-add:hover {\n    background: var(--primary600) !important;\n}\n\n.custom-popup-draft #custom-draft-button-add:disabled {\n    background: var(--primary50) !important;\n}\n\n.custom-popup-draft .rdw-link-modal-btn {\n    box-shadow: none !important;\n    margin: 0 5px !important;\n    border-radius: var(--r-xs) !important;\n    height: 39px !important;\n    min-width: 100px !important;\n    color: var(--black);\n    font-weight: var(--fw-semibold);\n}\n\n.custom-popup-draft .rdw-link-modal-btn:hover {\n    background: var(--neutral100) !important;\n}\n\n.custom-popup-draft::before {\n    content: 'Add link';\n    color: var(--black);\n    font-weight: var(--fw-bold);\n    background: var(--neutral50);\n    padding: 10px 15px;\n    box-sizing: border-box;\n    width: calc(100% + 30px);\n    transform: translate(-15px, -15px);\n}\n\n.custom-draft-button {\n    padding: 0;\n    min-height: 32px !important;\n    min-width: 32px !important;\n    border: 1px solid var(--neutral200) !important;\n    margin: 0 8px 0 0 !important;\n    box-shadow: none !important;\n    border-radius: var(--r-xs) !important;\n}\n\n.custom-draft-button > img {\n    max-height: 14px;\n    max-width: 14px;\n}\n\n.custom-draft-button:hover,\n.custom-draft-button:active {\n    background: var(--neutral100) !important;\n}\n\n.rdw-option-active {\n    background: var(--neutral100) !important;\n    box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
